import RefreshIcon from "@mui/icons-material/Refresh";
import React from "react";
import { Dropdown } from "react-bootstrap";
import CSVIcon from "../../../assets/icons/CSV.svg";
import XLSIcon from "../../../assets/icons/XLS.svg";
import ExportIcon from "../../../assets/media/svg/icons/Files/Export-blue.svg";
import AngleDown from "../../../assets/media/svg/icons/Navigation/Angle-down.svg";

const FeedsHeader = ({ setCallFeedsAgain }) => {
	return (
		<div className="tasks-h d-flex justify-content-between align-items-start mb-5">
			<div className="d-flex align-items-center">
				<p className="m-0 font-16">Feed</p>
			</div>
			<div
				className="pastoral__refresh-icon cursor-pointer"
				onClick={() => {
					setCallFeedsAgain((prevState) => !prevState);
				}}
			>
				<RefreshIcon
					className="svg-icon"
					sx={{
						color: "#4D5565",
						width: "20px",
					}}
				/>
			</div>
			{/* <div className="d-flex">
				<div
					className="feed-export-drop d-flex justify-content-center align-items-center mr-3"
					style={{ width: "120px" }}
				>
					<Dropdown>
						<Dropdown.Toggle id="dropdown-basic" className="d-flex align-items-center feed-export-dropdown">
							<img src={ExportIcon} className="export-icon" width="10px" /> Export Data
							<img src={AngleDown} className=" ml-1" width="15px" />
						</Dropdown.Toggle>

						<Dropdown.Menu>
							<Dropdown.Item href="#/action-1">
								{" "}
								<img src={CSVIcon} className="mr-2" /> CSV
							</Dropdown.Item>
							<Dropdown.Item href="#/action-2">
								{" "}
								<img src={XLSIcon} className="mr-2" /> XLS
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</div>
				<div className="feed-export-drop d-flex justify-content-center align-items-center px-1">
            <Dropdown>
              <Dropdown.Toggle
                id="dropdown-basic"
                className="d-flex align-items-center feed-export-dropdown"
              >
                show : {feedType}
                <img src={AngleDown} className=" ml-1" width="15px" />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  id="all"
                  onClick={(e) => setFeedType(e.target.id)}
                >
                  {" "}
                  all
                </Dropdown.Item>
                <Dropdown.Item
                  id="new"
                  onClick={(e) => setFeedType(e.target.id)}
                >
                  New
                </Dropdown.Item>
                <Dropdown.Item
                  id="completed"
                  onClick={(e) => setFeedType(e.target.id)}
                >
                  Completed
                </Dropdown.Item>
                <Dropdown.Item
                  id="updated"
                  onClick={(e) => setFeedType(e.target.id)}
                >
                  {" "}
                  Updated
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
			</div> */}
		</div>
	);
};

export default FeedsHeader;
